import React from 'react'
import './App.css'
import './Profile.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { RiEditLine } from 'react-icons/ri'
import { IoPersonOutline, IoCardOutline, IoShareSocialOutline } from 'react-icons/io5'
import SideNavCust from './layouts/SideNavCust'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { BiMenu } from 'react-icons/bi'
import SideNavAff from './layouts/SideNavAff'
import { API_URL } from './config'

/* Display-only helpers */
const Field = ({ label, children, wide }) => (
  <div className={`pf-field ${wide ? 'pf-field--wide' : ''}`}>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
)

const roleLabel = (accountType) =>
  accountType === 'partner'
    ? 'Affiliate'
    : accountType === 'customer'
      ? 'Attendee'
      : accountType === 'business'
        ? 'Organiser'
        : ''

class Profile extends React.Component {
  constructor(props) {
    super(props)
    const isMobile = window.innerWidth <= 768
    this.state = {
      query: '',
      password: '',
      response: '',
      error: '',
      errorDisplay: 'none',
      customername: '',
      businessname: '',
      affiliate: '',
      phone: '',
      email: '',
      dtregistered: '',
      bankname: '',
      account: '',
      accountnumber: '',
      branchcode: '',
      accountType: '',
      updated_at: '',
      isMobile,
      collapsed: isMobile,
    }
  }

  componentDidMount() {
    this.updateIsMobile()
    window.addEventListener('resize', this.updateIsMobile)

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=ACCOUNTTYPE`, {
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          accountType: response.data.account_type,
        })
      })
      .catch((error) => {
        console.log(error)
      })

    if (localStorage.getItem('customername')) {
      const customername = localStorage.getItem('customername')
      const customerid = localStorage.getItem('customerid')
      document.title = customername + ' | Profile'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            customername: response.data.customername,
            phone: response.data.phone,
            email: response.data.email,
            dtregistered: response.data.dtregistered,
            facebook: '',
            twitter: '',
            instagram: '',
            linkedin: '',
            tiktok: '',
            address: '',
            updated_at: response.data.updated_at,
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    } else if (localStorage.getItem('businessname')) {
      const businessname = localStorage.getItem('businessname')
      const businessid = localStorage.getItem('businessid')
      document.title = 'Profile - ' + businessname + ' - Businessname'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=BUSINESSDETAILS&accountid=${businessid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            businessname: response.data.businessname ?? 'N/A',
            phone: response.data.phone ?? 'N/A',
            email: response.data.email ?? 'N/A',
            dtregistered: response.data.dtregistered ?? 'N/A',
            facebook: response.data.facebook ?? 'N/A',
            bankname: response.data.bankname ?? 'N/A',
            branchcode: response.data.branchcode ?? 'N/A',
            account: response.data.account ?? 'N/A',
            accountnumber: response.data.accountnumber ?? 'N/A',

            twitter: response.data.twitter ?? 'N/A',
            instagram: response.data.instagram ?? 'N/A',
            linkedin: response.data.linkedin || '',
            tiktok: response.data.tiktok || '',
            address: response.data.address ?? 'N/A',
            updated_at: response.data.updated_at ?? 'N/A',
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    } else {
      const partnername = localStorage.getItem('partnername')
      const partnerid = localStorage.getItem('partnerid')
      document.title = 'Karamale | Profile'

      Axios.get(
        `${API_URL}/apps/kscanner/webservices.php?query=PARTNERDETAILS&partnerid=${partnerid}`,
        {
          withCredentials: true,
        },
      )
        .then((response) => {
          this.setState({
            affiliate: response.data.partnername || '',
            phone: response.data.phone || '',
            email: response.data.email || '',
            dtregistered: response.data.dtregistered || '',
            bankname: response.data.bankname || '',
            branchcode: response.data.branchcode ?? '',
            account: response.data.account || '',
            accountnumber: response.data.accountnumber || '',
            updated_at: response.data.updated_at || '',

            facebook: response.data.facebook || '',
            twitter: response.data.twitter || '',
            instagram: response.data.instagram || '',
            linkedin: response.data.linkedin || '',
            tiktok: response.data.tiktok || '',
          })
        })
        .catch(function (error) {
          console.log('Error: ', error)
        })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateIsMobile)
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }))
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }))
  }

  render() {
    let { accountname, dashboard } = ''
    if (localStorage.getItem('customername') === null) {
      if (localStorage.getItem('businessname') === null) {
        if (localStorage.getItem('partnername') === null) {
          return <Redirect to="/login" />
        } else {
          accountname = this.state.affiliate
          dashboard = 'in'
        }
      } else {
        accountname = this.state.businessname
        dashboard = 'dashboard'
      }
    } else {
      accountname = this.state.customername
    }
    const customername = accountname
    const twitter = this.state.twitter

    const str = String(this.state.accountnumber || '00000000000')
    const last4 = str.slice(-4)
    const masked = '*'.repeat(str.length - 4) + last4

    const accounttype = localStorage.getItem('accounttype')
    const { collapsed, isMobile } = this.state

    const social = (value) => (value === '' ? 'pf-link pf-link--muted' : 'pf-link')

    return (
      <div className="view">
        <Header />
        {accounttype === 'customer' ? (
          <>
            {' '}
            <SideNavCust collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : accounttype === 'business' ? (
          <>
            <SideNav collapsed={this.state.collapsed} onToggle={this.handleToggle} />
          </>
        ) : (
          <SideNavAff collapsed={this.state.collapsed} onToggle={this.handleToggle} />
        )}

        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && (
          <div className="mobile-overlay active" onClick={this.handleToggle} />
        )}

        {this.state.isMobile && this.state.collapsed && (
          <label className="mobile-toggle" onClick={this.handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <main
          className="pf-page"
          style={{
            marginTop: 'var(--header-h)',
            marginLeft: this.state.isMobile ? 0 : this.state.collapsed ? '76px' : '252px',
          }}
        >
          <div className="pf-container">
            <div className="pf-top">
              <button type="button" className="pf-back" onClick={() => this.props.history.goBack()}>
                <IoIosArrowBack size={18} />
                <span>Back</span>
              </button>

              <Link
                to={{
                  pathname: 'editprofile',
                  state: {
                    accountname: customername,
                    email: this.state.email,
                    phone: this.state.phone,
                    dtregistered: this.state.dtregistered,
                    facebook: this.state.facebook,
                    twitter: this.state.twitter,
                    instagram: this.state.instagram,
                    address: this.state.address,
                  },
                }}
                className="pf-edit"
              >
                <RiEditLine size={16} />
                Edit
              </Link>
            </div>

            {/* Identity card */}
            <section className="pf-hero">
              <div className="pf-avatar">{(customername || '?').charAt(0).toUpperCase()}</div>

              <div className="pf-hero__text">
                <h1>{customername}</h1>
                <p>{this.state.email}</p>
                {roleLabel(this.state.accountType) && (
                  <span className="pf-role">{roleLabel(this.state.accountType)}</span>
                )}
              </div>

              {/* {(this.state.accountType === 'business' || this.state.accountType === 'customer') && (
                <Link to="/b-details" className="pf-hero__link">
                  Bank Details
                </Link>
              )} */}

              {(this.state.accountType === 'business' || this.state.accountType === 'partner') && (
                <Link to="/b-details" className="pf-hero__link">
                  Bank Details
                </Link>
              )}
            </section>

            {/* My account */}
            <section className="pf-card">
              <div className="pf-card__head">
                <h2>
                  <IoPersonOutline size={18} />
                  My account
                </h2>
                <Link
                  to={{
                    pathname: '/changepassword',
                    state: {
                      credentials: 'password',
                    },
                  }}
                  className="pf-link"
                >
                  Change Password
                </Link>
              </div>

              <dl className="pf-grid">
                <Field
                  label={
                    this.state.accountType === 'partner'
                      ? 'Affiliate name'
                      : this.state.accountType === 'customer'
                        ? 'Name and surname'
                        : this.state.accountType === 'business'
                          ? 'Business name'
                          : 'Name and surname'
                  }
                >
                  {customername}
                </Field>
                <Field label="Email address">{this.state.email}</Field>
                <Field label="Phone number">{this.state.phone}</Field>
                <Field label="Account created">{this.state.dtregistered}</Field>
                <Field label="Updated on">{this.state.updated_at}</Field>
              </dl>
            </section>

            {/* Bank details (partner only) */}
            {this.state.accountType === 'partner' && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoCardOutline size={18} />
                    Bank details
                  </h2>
                  <Link to="/b-details" className="pf-link">
                    Add/Edit
                  </Link>
                </div>

                <dl className="pf-grid">
                  <Field label="Bank name">{this.state.bankname}</Field>
                  <Field label="Branch code">{this.state.branchcode}</Field>
                  <Field label="Account type">{this.state.account}</Field>
                  <Field label="Account number">{masked}</Field>
                </dl>
              </section>
            )}

            {/* Social media (not for customers) */}
            {this.state.accountType !== 'customer' && (
              <section className="pf-card">
                <div className="pf-card__head">
                  <h2>
                    <IoShareSocialOutline size={18} />
                    Social media
                  </h2>
                </div>

                <dl className="pf-grid">
                  <Field label="Facebook">
                    <Link
                      to={{ pathname: this.state.facebook || '#' }}
                      target="_blank"
                      className={social(this.state.facebook)}
                    >
                      {this.state.facebook}
                    </Link>
                    {this.state.facebook === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="X/Twitter">
                    <Link
                      to={{
                        pathname: this.state.twitter,
                      }}
                      target="_blank"
                      className={social(this.state.twitter)}
                    >
                      {this.state.twitter}
                    </Link>
                    {this.state.twitter === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="Instagram">
                    <Link
                      to={{
                        pathname: this.state.instagram,
                      }}
                      target="_blank"
                      className={social(this.state.instagram)}
                    >
                      {this.state.instagram}
                    </Link>
                    {this.state.instagram === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="Linkedin">
                    <Link
                      to={{
                        pathname: this.state.linkedin,
                      }}
                      target="_blank"
                      className={social(this.state.linkedin)}
                    >
                      {this.state.linkedin}
                    </Link>
                    {this.state.linkedin === '' ? 'Link not added' : ''}
                  </Field>

                  <Field label="Tiktok">
                    <Link
                      to={{
                        pathname: this.state.tiktok || '#',
                      }}
                      target="_blank"
                      className={social(this.state.tiktok)}
                    >
                      {this.state.tiktok}
                    </Link>
                    {this.state.tiktok === '' ? 'Link not added' : ''}
                  </Field>

                  {this.state.accountType === 'business' ? (
                    <Field label="Business address" wide>
                      <span className="pf-preline">
                        {this.state.address == '' ? 'Address not added' : this.state.address}
                      </span>
                    </Field>
                  ) : (
                    ''
                  )}
                </dl>
              </section>
            )}
          </div>
        </main>

        <div
          className="error-login"
          style={{ display: this.state.errorDisplay, textAlign: 'center' }}
        >
          {this.state.error}
        </div>
      </div>
    )
  }
}

export default Profile
